import { publicAccountClient } from '../../common/client/apollo-client';
import { loader } from 'graphql.macro';
import IRegistrationStatusResponse from '../models/registration-status-response-interface';
import { trackCustomHeapEvent } from '../../../utils/heap';

const registrationStatusQuery: any = loader('../../../graphql/queries/registration-status.graphql');

class Auth0Registration {

  async getCurrentStatus(correlationId: string): Promise<IRegistrationStatusResponse> {
    try {
      const response = await publicAccountClient().query<{ registrationStatus: IRegistrationStatusResponse }>({
        query: registrationStatusQuery,
        variables: { correlationId },
        fetchPolicy: 'no-cache'
      });

      const registrationStatus = response?.data?.registrationStatus;
      if (!registrationStatus || typeof registrationStatus.status !== 'string') {
        throw new Error('Registration status was not returned');
      }

      trackCustomHeapEvent('auth0-status-check-success', {});
      return registrationStatus;
    } catch (error) {
      trackCustomHeapEvent('auth0-status-check-error', {});
      throw error;
    }
  }
}

export default Auth0Registration;

